import { api } from '@/services'

export const list = (params) => {
  return api.get('/admin/itemCategory/list', { params })
}

export const show = (id) => {
  return api.get(`/admin/itemCategory/show/${id}`)
}

export const edit = (category) => {
  return api.put('/admin/itemCategory/update', category)
}

export const create = (category) => {
  return api.post('/admin/itemCategory/create', category)
}

export const remove = (id) => {
  return api.delete(`admin/itemCategory/delete/${id}`)
}
